module.exports = {"230221100":"龙江镇","230221101":"景星镇","230221102":"龙兴镇","230221103":"山泉镇","230221104":"七棵树镇","230221105":"杏山镇","230221106":"白山镇","230221107":"头站镇","230221201":"黑岗乡","230221202":"广厚乡","230221203":"华民乡","230221204":"哈拉海乡","230221215":"鲁河乡","230221217":"济沁河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230221.json
// module id = 786
// module chunks = 0